import React, { useState } from 'react'
import * as UIcons from '@iconscout/react-unicons'
import StatCard from 'components/DetailWidgets/StatCard'
import TabTable from '../TabTable'
import ReviewDetailDrawer from './ReviewDetailDrawer'

function RatingBar({ label, percent, count, color }) {
  return (
    <div className="flex items-center gap-3">
      <span className="text-sm text-dark-blue w-16 shrink-0">{label}</span>
      <div className="flex-1 h-2 rounded-full bg-background overflow-hidden">
        <div className="h-full rounded-full" style={{ width: `${percent}%`, backgroundColor: color }} />
      </div>
      <span className="text-sm text-secondary w-28 text-right shrink-0">{count}</span>
    </div>
  )
}

const COLUMNS = [
  { key: 'reviewer', label: 'Reviewer' },
  {
    key: 'rating',
    label: 'Rating',
    render: (row) => <span className="text-gold">{'★'.repeat(row.rating)}{'☆'.repeat(5 - row.rating)}</span>
  },
  { key: 'comment', label: 'Comment' },
  { key: 'date', label: 'Date' }
]

export default function ReviewTab({ campaign }) {
  const { review } = campaign
  const [selectedReview, setSelectedReview] = useState(null)

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {
          review.stats.map((stat) => (
            <StatCard key={stat.key} icon={UIcons.UilStar} label={stat.label} value={stat.value} suffix={stat.suffix} trend={stat.trend} tone={stat.tone} />
          ))
        }
      </div>

      <div className="w-full rounded-2xl border border-border-lines p-4">
        <p className="text-base font-semibold text-dark-blue mb-4">Rating Distribution</p>
        <div className="flex flex-col gap-3">
          {
            review.ratingDistribution.map((row) => (
              <RatingBar key={row.label} label={row.label} percent={row.percent} count={row.count} color={row.color} />
            ))
          }
        </div>
      </div>

      <TabTable
        columns={COLUMNS}
        rows={review.rows}
        searchPlaceholder="Search by reviewer name"
        searchKeys={['reviewer', 'comment']}
        onRowClick={setSelectedReview}
      />

      {selectedReview && <ReviewDetailDrawer review={selectedReview} onClose={() => setSelectedReview(null)} />}
    </div>
  )
}
